import { WIDGET_SUPPORT_CHATBOT, WidgetEvents } from '@wix/wix-chatbot-common/browser';

export const postUrlChange = (url: string): void => {
  window.parent.postMessage({
    type: WIDGET_SUPPORT_CHATBOT,
    data: { event: WidgetEvents.UPDATE_WIDGET_URL, payload: { url } },
  });
};
